import React from 'react'

const initialState = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
}

/**
 * A function which returns the time until a certain date/time.
 *
 * @param dateTime - The target date/time to calculate time until
 * @returns - An object with the days, hours, minutes and seconds until the
 * target date
 */
const getTimeUntilDate = (difference: number) => {
    let timeLeft = initialState

    if (difference > 0) {
        timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
        }
    }

    return timeLeft
}

/**
 * A hook which calculates the time until a certain date/time, updates every
 * second and returns the updated values.
 *
 * @param dateTime - The target date/time to count down to
 * @returns - An object with the days, hours, minutes and seconds until the
 * target date
 */
export const useCountdown = (dateTime: string) => {
    const [timeLeft, setTimeLeft] = React.useState(initialState)
    const [hasMounted, setHasMounted] = React.useState(false)

    React.useEffect(() => {
        const timer = setInterval(() => {
            const difference = +new Date(dateTime) - +new Date()
            setHasMounted(true)

            setTimeLeft(getTimeUntilDate(difference))
        }, 1000)

        return () => clearInterval(timer)
    }, [dateTime])

    return {...timeLeft, hasMounted}
}
